import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Field, useFormikContext } from "formik";
import { unwrapResult } from "@reduxjs/toolkit";
import { Heading, Thead, Th, Tr, Td, Tbody, Checkbox, CheckboxGroup, Button, Box } from "@chakra-ui/react";
import { getOfficeWeek } from "../../features/week/officeWeekSlice";
import RegisterStudent from "../../Students/pages/StudentFieldSet";
import { HoverableTable } from "../../components/UIElements/HoverableTable";
import Spinner from "../../components/FormElements/Spinner";

const isIdValid = (id = 1, officeWeek) => {
  return officeWeek.some((week) => week.location_id === Number(id));
}

const OfficeWeek = (props) => {
  const dispatch = useDispatch();
  const { values } = useFormikContext();
  const [officeWeek, setOfficeWeek] = useState([]);
  const [checkedLineNo, setCheckedLineNo] = useState();
  const [error, setError] = useState(null);
  const [isEditingWeek, setIsEditingWeek] = useState(false);

  useEffect(() => {
    if (!isIdValid(values.location_id, officeWeek)) {
      setCheckedLineNo(undefined);
      props.onDateUpdate(undefined);
    }
    dispatch(getOfficeWeek(values.location_id))
      .then(unwrapResult)
      .then((result) => {
        if (!result?.length) {
          setError("Thank you for your interest in our TY Programme. Currently our TY Programme is fully booked. Places are on a first come first serve basis. In case there is a cancellation, the dates will reflect below, and you will be able to book a space. We wish you the very best!");
          setCheckedLineNo(undefined)
        } else {
          setError(null);
          setOfficeWeek(result);
          if (values.week_starting_date && values.location_id) {
            const index = result.findIndex(
              (week) => week.week_starting_date === values.week_starting_date
            );
            setCheckedLineNo(index);
            props.onDateUpdate(values.week_starting_date);
          }
        }
      })
      .catch((error) => {
        console.error("GetOfficeWeek Dispatch ", error);
      });
  }, [dispatch, setOfficeWeek, values.location_id]);

  const onChange = (index) => {
    setCheckedLineNo(index);
    props.onDateUpdate(officeWeek[index].week_starting_date);
    return;
  };

  if (error) {
    return (
      <>
       <div className="error"><p>{error}</p></div>
      
      </>
    );
  }

  if (!isIdValid(values.location_id, officeWeek)) {
    return (
      <>
        <Heading as="h3" size="sm" fontWeight="semibold" mt="2em" mb="0">Select Preferred Week</Heading>
        <div style={{height: "500px"}}></div>
        <Spinner />
      </>
    );
  } 

  const isWeekSelected = values?.week_starting_date && officeWeek.some(week => week.week_starting_date === values.week_starting_date);

  return (
    <>
      <Heading as="h3" size="sm" fontWeight="semibold" mt="2em" mb="0">{isWeekSelected ? "" : "Select "}Preferred Week</Heading>
      {
        isWeekSelected && !isEditingWeek ? (
          <Box display="flex" alignItems="center" gap="1em" flexDirection="row">
            <p>{values.week_starting_date} - {officeWeek.find(week => week.week_starting_date === values.week_starting_date)?.week_ending_date}</p>
            <Button onClick={() => setIsEditingWeek(true)} size="sm">Edit</Button>
          </Box>
        ) : (
          <>
            <Field name="week_starting_date" style={{position: "fixed", top: "-0000px"}} />
              <CheckboxGroup colorScheme="red" value={officeWeek && officeWeek[0] && officeWeek[0].week_starting_date}>
                <HoverableTable>
                  <Thead>
                    <Tr>
                      <Th></Th>
                      <Th>Week Startdate</Th>
                      <Th>Week Enddate</Th>
                      <Th>Places Available</Th>
                      <Th>Max Places</Th>
                    </Tr>
                  </Thead>
                  <Tbody fontWeight="normal">
                    {officeWeek.map((officeWeek, index) => (
                      <Tr
                        key={officeWeek.date_key}
                      >
                        <Td><Checkbox onChange={() => onChange(index)} isChecked={index === checkedLineNo} /></Td>
                        <Td>{officeWeek.week_starting_date}</Td>
                        <Td>{officeWeek.week_ending_date}</Td>
                        <Td textAlign="center">{officeWeek.available_spaces}</Td>
                        <Td textAlign="center">{officeWeek.max_students}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </HoverableTable>
              </CheckboxGroup>
          </>
        )
      }
      
      {checkedLineNo !== undefined ? (
        <>
          <Heading as="h3" size="md" fontWeight="semibold" mt
          ="3em" mb="1.5em">Please Enter Student Details</Heading>
          <RegisterStudent locationId={values.location_id} onSelectedSchoolChange={props.onSelectedSchoolChange} onSelectedGenderChange={props.onSelectedGenderChange}  formik={props.formik} />
        </>
      ) : (
        <> </>
      )}
    </>
  );
};

export default OfficeWeek;